// extracted by mini-css-extract-plugin
export default {"BreakpointToMedium":"(max-width: 639px)","baseOffset":"0.25rem","desktopOffset":"0.5rem","recipeTileBadge":"G993639"};